import { computed, observable } from 'mobx';
import { EmailNotificationDigestType, IUser } from '../Models/IUser';
import { UserProfileService } from '../Services/UserProfileService';
import { AuthorizationStore } from '../_stores/AuthorizationStore';

export class UserProfileStore {
    private userProfileService: UserProfileService;
    private authorizationStore: AuthorizationStore;

    @observable
    private _user!: IUser;

    @computed
    public get user() {
        return this._user;
    }

    public constructor(token: string, authStore: AuthorizationStore) {
        this.userProfileService = new UserProfileService(token);
        this.authorizationStore = authStore;

        this.loadCurrentUser().catch(() => {
            this._user = {
                id: 0,
                profile_image_url: '',
                email: '',
                created_at: new Date(),
                last_login_at: new Date(),
                first_name: '',
                last_name: '',
                email_notification_digest_type_id: 0,
                facts: []
            };
        });
    }

    public get userIsLoaded(): boolean {
        return !!this._user && this._user.id !== 0;
    }

    public async loadCurrentUser(): Promise<void> {
        if (!this.authorizationStore.authIsResolved || !this.authorizationStore.isAuthenticated) {
            throw new Error('Cannot load user if no user logged in');
        }
        this._user = await this.userProfileService.getUserByID(this.authorizationStore.user.id);
    }

    public async updateNotificationFrequency(frequency: EmailNotificationDigestType): Promise<boolean> {
        const response = await this.userProfileService.updateProfile({ email_notification_digest_type_id: frequency }, null, false);
        this.loadCurrentUser();
        return response;
    }

    public async updateUserProfile(profile: Partial<IUser>, file: File | null, shouldRemovePhoto: boolean): Promise<boolean> {
        const response = await this.userProfileService.updateProfile(profile, file, shouldRemovePhoto);
        await this.loadCurrentUser();
        return response;
    }
}



// WEBPACK FOOTER //
// ./src/Stores/UserProfileStore.ts